import { Market } from "@config/site/types";

//^0(?:\d-\d{4}-\d{4}       # 10 digits -> 0x-xxxx-xxxx
//  |\d{2}-\d{3}-\d{4}      # 10 digits -> 0xx-xxx-xxxx
//  |\d{2}-\d{4}-\d{3}      # 10 digits -> 0xx-xxxx-xxx
//  |\d{3}-\d{2}-\d{4}      # 10 digits -> 0xxx-xx-xxxx
//  |\d{4}-\d-\d{4}         # 10 digits -> 0xxxx-x-xxxx
//  |\d{9}                  # 10 digits -> 0xxxxxxxxx
//  |\d{2}-\d{4}-\d{4}      # 11 digits -> 0xx-xxxx-xxxx
//  |\d{10}                 # 11 digits -> 0xxxxxxxxxx
//)$
const JPPhoneNumber =
    /^0(?:\d-\d{4}-\d{4}|\d{2}-\d{3}-\d{4}|\d{2}-\d{4}-\d{3}|\d{3}-\d{2}-\d{4}|\d{4}-\d-\d{4}|\d{9}|\d{2}-\d{4}-\d{4}|\d{10})$/;

/**
 * @description Australian mobile: must start with 4 and be exactly 9 digits (4XX XXX XXX),
 * combined with the +61 country code to form +61 4XX XXX XXX for AusPost manifesting.
 */
const AUPhoneNumber = /^4\d{8}$/;

/**
 * @description
 * | Type       | Area Code / Prefix          | Digit excl. prefix  | Example
 * ==========================================================================================
 * | Mobile     | 02                          | 7-9 digits          | 021 123 4567
 * | Landline   | 03, 04, 06, 07, 09 (not 090)| 7 digits            | 09 377 1234
 */
const NZPhoneNumber = /^(?:0(?:2\d{7,9}|[3467]\d{7}|9(?!0)\d{7}))$/;

/**
 * @description Should be 10 digits.
 */
const CAPhoneNumber = /^\d{10}$/;

/**
 * @description Should be 10 digits.
 */
const USPhoneNumber = /^\d{10}$/;

/**
 * @description Should be 10 digits.
 */
const INPhoneNumber = /^\d{10}$/;

/**
 * @description Should be 7 or 8 digits (Estonia).
 */
const EEPhoneNumber = /^\d{7,8}$/;

/**
 * @description Should be 9 digits.
 */
const ESPhoneNumber = /^\d{9}$/;

/**
 * @description Should start with 0 and be 11 digits.
 */
const KRPhoneNumber = /^0\d{10}$/;

/**
 * @description Should start with digits 1 or 3-9 and be 9 or 10 digits.
 */
const MYPhoneNumber = /^[13-9]\d{8,9}$/;

/**
 * @description Should start with 6, 8, or 9 and be 8 digits.
 */
const SGPhoneNumber = /^[689]{1}\d{7}$/;

/**
 * @description Should be 7 to 11 digits.
 */
const HUPhoneNumber = /^\d{7,11}$/;

/**
 * @description Should be 8 to 11 digits.
 */
const DEPhoneNumber = /^\d{8,11}$/;

/**
 * @description Should be 7 to 11 digits.
 */
const ATPhoneNumber = /^\d{7,11}$/;

/**
 * @description Should be 9 to 10 digits.
 */
const NLPhoneNumber = /^\d{9,10}$/;

/**
 * @description Should be 9 to 10 digits.
 */
const CHPhoneNumber = /^\d{9,10}$/;

/**
 * @description Should be exactly 9 digits (Poland).
 */
const PLPhoneNumber = /^\d{9}$/;

/**
 * @description (Czech Republic)
 * Starts with 6 or 7
 * Exactly 9 digits.
 */
const CZPhoneNumber = /^[67][0-9]{8}$/;

/**
 * @description Should be exactly 8 digits (Cyprus).
 */
const CYPhoneNumber = /^\d{8}$/;

/**
 * @description Should be exactly 8 digits (Denmark).
 */
const DKPhoneNumber = /^\d{8}$/;

/**
 * @description Should be 8 to 10 digits (Belgium).
 */
const BEPhoneNumber = /^\d{8,10}$/;

/**
 * @description Should be 7 to 10 digits. (Finland).
 */
const FIPhoneNumber = /^\d{7,10}$/;

/**
 * @description Should be 9 to 10 digits. (France).
 */
const FRPhoneNumber = /^\d{9,10}$/;

/**
 * @description Should be 10 to 11 digits. (United Kingdom).
 */
const GBPhoneNumber = /^\d{10,11}$/;

/**
 * @description Should be 8 to 10 digits. (Croatia).
 */
const HRPhoneNumber = /^\d{8,10}$/;

/**
 * @description Should be 9 to 10 digits. (Ireland).
 */
const IEPhoneNumber = /^\d{9,10}$/;

/**
 * @description Should be 8 to 9 digits. (Lithuania).
 */
const LTPhoneNumber = /^\d{8,9}$/;

/**
 * @description Should be 8 digits. (Latvia).
 */
const LVPhoneNumber = /^\d{8}$/;

/**
 * @description Should be 8 digits. (Norway).
 */
const NOPhoneNumber = /^\d{8}$/;

/**
 * @description Should be 9 digits. (Portugal).
 */
const PTPhoneNumber = /^\d{9}$/;

/**
 * @description Should be 9 to 10 digits. (Sweden).
 */
const SEPhoneNumber = /^\d{9,10}$/;

/**
 * @description Should be 8 to 9 digits. (Slovenia).
 */
const SIPhoneNumber = /^\d{8,9}$/;

/**
 * @description Should be exactly 9 digits. (Slovakia).
 */
const SKPhoneNumber = /^\d{9}$/;

export const phoneNumberRegex: Record<Market, RegExp | null> = {
    /** EMEA */
    [Market.AT]: ATPhoneNumber,
    [Market.BE]: BEPhoneNumber,
    [Market.CH]: CHPhoneNumber,
    [Market.CY]: CYPhoneNumber,
    [Market.CZ]: CZPhoneNumber,
    [Market.DE]: DEPhoneNumber,
    [Market.DK]: DKPhoneNumber,
    [Market.EE]: EEPhoneNumber,
    [Market.ES]: ESPhoneNumber,
    [Market.FI]: FIPhoneNumber,
    [Market.FR]: FRPhoneNumber,
    [Market.GB]: GBPhoneNumber,
    [Market.HR]: HRPhoneNumber,
    [Market.HU]: HUPhoneNumber,
    [Market.IE]: IEPhoneNumber,
    [Market.LT]: LTPhoneNumber,
    [Market.LV]: LVPhoneNumber,
    [Market.NL]: NLPhoneNumber,
    [Market.NO]: NOPhoneNumber,
    [Market.PL]: PLPhoneNumber,
    [Market.PT]: PTPhoneNumber,
    [Market.SE]: SEPhoneNumber,
    [Market.SI]: SIPhoneNumber,
    [Market.SK]: SKPhoneNumber,

    /** EAP */
    [Market.AU]: AUPhoneNumber,
    [Market.IN]: INPhoneNumber,
    [Market.JP]: JPPhoneNumber,
    [Market.KR]: KRPhoneNumber,
    [Market.MY]: MYPhoneNumber,
    [Market.NZ]: NZPhoneNumber,
    [Market.SG]: SGPhoneNumber,

    /** EAM */
    [Market.CA]: CAPhoneNumber,
    [Market.US]: USPhoneNumber,
};
